export var ROLE_STUDENT = 'STUDENT';
export var ROLE_TEACHER = 'TEACHER';
export var ROLE_ADMINISTRATOR = 'SCHOOL_ADMINISTRATOR';
export var ROLE_SYSADMIN = 'SYSADMIN';
export var ROLE_MENTOR = 'MENTOR';
export var ROLE_COURSE_ADMIN = 'COURSE_ADMINISTRATOR';
export var ROLE_STANDARD_CURRICULUM_ADMIN = 'STANDARD_CURRICULUM_ADMIN';
export var ROLE_CONVERSATION_ADMIN = 'CONVERSATION_ADMIN';
export var ROLE_SPECIAL_PEDAGOGUE = 'SPECIAL_PEDAGOGUE';